<xux-progress-bar
  [data]="progressBarData"
  [NoDataText]="NoDataText | translate"
  (hoverEvent)="handleHover($event)"
></xux-progress-bar>
<div class="transfer box-content">
  <ng-container *ngFor="let summary of summaryList">
    <div
      class="flex-item"
      (click)="gotoTransferPage(summary.status)"
      [ngClass]="{ hovered: summary.isHovered }"
    >
      <div class="label-text">
        {{ summary.text }}<span class="num">{{ summary.count }}</span>
      </div>
      <img src="{{ 'assets/img/right.png' | xviSourcePath }}" />
    </div>
  </ng-container>
</div>
